import { CommentsReactions, StoryCard } from '../../services';

interface ReactOnCommentReducerArgs {
  card: StoryCard;
  commentId: number;
  reactions: CommentsReactions[];
}

export const reactOnCommentReducer = ({
  card,
  commentId,
  reactions,
}: ReactOnCommentReducerArgs) => {
  const { comments } = card;

  const commentsAndReplies = comments.flatMap((comment) => {
    return [comment, ...comment.replies];
  });

  const comment = commentsAndReplies.find(({ id }) => id === commentId);

  if (!comment) {
    return;
  }

  comment.myReaction = comment.myReaction ? '' : 'like';
  comment.reactions = reactions;
};
